
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("volta/_pods/login/template", function(){ return i("../../_pods/login/template.hbs");});
d("volta/_pods/login/route", function(){ return i("../../_pods/login/route.ts");});
